<template>
    <nav :aria-label="$t('common.pageNavigation')" class="m-0">
        <ul class="pagination m-0">
            <li class="page-item"
                :class="{ 'disabled': !hasPrevious }"
                @click="toPrevious"
                :title="$t('common.toPreviousPage')">
                <a class="page-link" href="javascript://"><span aria-hidden="true">&laquo;</span></a>
            </li>
            <li class="page-item"
                :class="getClassActive(1)"
                @click="toFirst"
                :title="$t('common.toFirstPage')">
                <a class="page-link" href="javascript://">1</a>
            </li>

            <li class="page-item disabled" v-if="showLeftDelimiter">
                <a class="page-link" href="javascript://"><span aria-hidden="true">...</span></a>
            </li>

            <li v-for="page in pagesNumbers"
                class="page-item"
                :class="getClassActive(page)"
                @click="toNumber(page)">
                <a class="page-link" href="javascript://">{{ page }}</a>
            </li>

            <li class="page-item disabled" v-if="showRightDelimiter">
                <a class="page-link" href="javascript://"><span aria-hidden="true">...</span></a>
            </li>

            <li v-if="pagesCount > 1"
                class="page-item"
                :class="getClassActive(pagesCount)"
                @click="toLast"
                :title="$t('common.toLastPage')">
                <a class="page-link" href="javascript://">{{ pagesCount }}</a>
            </li>
            <li class="page-item"
                :class="{ 'disabled': !hasNext }"
                @click="toNext"
                :title="$t('common.toNextPage')">
                <a class="page-link" href="javascript://"><span aria-hidden="true">&raquo;</span></a>
            </li>
        </ul>
    </nav>
</template>

<script>
    const Pagination = {
        props: {
            value: {
                type: Number,
                required: false
            },
            totalRowsCount: {
                type: Number,
                required: true
            },
            pageRowsCount: {
                type: Number,
                required: true
            },
            showingPagesCount: {
                type: Number,
                required: false
            }
        },

        data() {
            return {
                currentPageNumber: this.value
            };
        },

        watch: {
            currentPageNumber(newNumber) {
                this.$emit("input", newNumber);
            }
        },

        computed: {
            pagesCount() {
                return Math.ceil(this.totalRowsCount / this.pageRowsCount);
            },

            aroundPagesCount() {
                return Math.floor(this.showingPagesCount / 2);
            },

            hasPrevious() {
                return this.currentPageNumber > 1;
            },

            hasNext() {
                return this.currentPageNumber < this.pagesCount;
            },

            showAll() {
                return this.pagesCount <= this.aroundPagesCount * 2 + 3;
            },

            showFromFirst() {
                return !this.showAll && this.currentPageNumber <= this.showingPagesCount;
            },

            showToLast() {
                return !this.showAll && this.currentPageNumber > this.pagesCount - this.showingPagesCount;
            },

            pagesNumbers() {
                const numbers = [];

                if (this.pagesCount <= 2) {
                    return numbers;
                }

                if (this.showAll) {
                    for (let number = 2; number < this.pagesCount; number++) {
                        numbers.push(number);
                    }

                    return numbers;
                }

                if (this.showFromFirst) {
                    for (let number = 2; number <= this.showingPagesCount; number++) {
                        numbers.push(number);
                    }

                    return numbers;
                }

                if (this.showToLast) {
                    for (let number = this.pagesCount - this.showingPagesCount + 1; number < this.pagesCount; number++) {
                        numbers.push(number);
                    }

                    return numbers;
                }

                for (let number = this.currentPageNumber - this.aroundPagesCount; number <= this.currentPageNumber + this.aroundPagesCount; number++) {
                    numbers.push(number);
                }

                return numbers;
            },

            showLeftDelimiter() {
                if (!this.pagesNumbers || this.pagesNumbers.length === 0) {
                    return false;
                }

                return this.pagesNumbers[0] !== 2;
            },

            showRightDelimiter() {
                if (!this.pagesNumbers || this.pagesNumbers.length === 0) {
                    return false;
                }

                return this.pagesNumbers[this.pagesNumbers.length - 1] !== this.pagesCount - 1;
            }
        },

        methods: {
            toFirst() {
                this.currentPageNumber = 1;
            },

            toLast() {
                this.currentPageNumber = this.pagesCount;
            },

            toPrevious() {
                if (this.hasPrevious) {
                    this.currentPageNumber--;
                }
            },

            toNext() {
                if (this.hasNext) {
                    this.currentPageNumber++;
                }
            },

            toNumber(number) {
                if (1 <= number && number <= this.pagesCount) {
                    this.currentPageNumber = number;
                }
            },

            getClassActive(pageNumber) {
                if (this.currentPageNumber === pageNumber) {
                    return "active";
                }

                return "";
            }
        }
    };

    export default Pagination;
</script>

<style>
    .pagination .page-btn {
        color: #007BFF;
        border: 2px solid #007BFF;
        border-left: 1px solid #007BFF;
        border-right: 1px solid #007BFF;
    }

        .pagination .page-btn.first-page {
            border-radius: 19px 0 0 19px;
            border-left: 2px solid #007BFF;
            border-right: 1px solid #007BFF;
        }

        .pagination .page-btn.last-page {
            border-radius: 0 19px 19px 0;
            border-left: 1px solid #007BFF;
            border-right: 2px solid #007BFF;
        }

    .pagination .between-buttons {
        border-left: 1px solid #007BFF;
        border-right: 1px solid #007BFF;
        width: 5px;
    }
</style>
